/**
 * A set of strings kept in local storage, such as the expanded nodes of a tree. Local
 * storage is a convenience: unreadable or malformed values count as absent.
 */
export function readStoredStringSet(storageKey: string): Set<string> | null {
  try {
    const saved = window.localStorage.getItem(storageKey);
    const parsed: unknown = saved === null ? null : JSON.parse(saved);
    if (Array.isArray(parsed)) {
      return new Set(parsed.filter((value): value is string => typeof value === "string"));
    }
  } catch {
    // Malformed or blocked storage: start fresh.
  }
  return null;
}

export function writeStoredStringSet(storageKey: string, values: ReadonlySet<string>): void {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(Array.from(values)));
  } catch {
    // Storage full or blocked: the set lives for this page only.
  }
}
